<template style="width: 0%; height: 0%;">
  <div class="login" :style="{ 'background-image': 'url(' + BGImageBig + ')' }">
    <el-switch v-model="language" @change="change_language" active-text="中" inactive-text="En"></el-switch>
    <!-- <img class="f" :src="BGImageBig" alt="" /> -->
    <div class="login-content">
      <div class="login-content-left" :style="{ 'background-image': 'url(' + BGImageSmall + ')' }">
        <!-- <img :src="BGImageSmall" alt="BGImageSmall" /> -->
      </div>
      <div class="login-content-right">
        <div>
          <div class="sxds" :style="{ 'background-image': 'url(' + CompanyLogo + ')' }">
          </div>
          <!-- <img :src="CompanyLogo" alt="" /> -->
          <span>{{ SystemNM }} </span>
        </div>

        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item prop="name">
            <el-input v-model="ruleForm.UserID" :placeholder="$t('original.psrzh')"></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 30px;" prop="password">
            <el-input type="password" v-model="ruleForm.PWD" :placeholder="$t('original.psrmm')"></el-input>
          </el-form-item>

          <el-form-item style="width:85% ;margin-bottom:5px">
            <el-row style="margin-top:10px;">
              <drag-verify ref="dragVerify" :width="250" :height="40" progressBarBg="#FFA500" background="#F5F5F5"
                :isPassing.sync="isPassing" :text="$t('original.sliding')" :successText="$t('original.through')"
                handlerIcon="el-icon-d-arrow-right" successIcon="el-icon-circle-check" @passcallback="passcallback2">
              </drag-verify>
            </el-row>
            <!-- <JcRange
                                      ref="JcRange"
                                      :successFun="verificationT()"
                                      :errorFun="verificationF()"
                                    ></JcRange> -->
            <!-- <JcRange status="status"></JcRange> -->
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="login()" :loading="loadding">
              {{ loadding ? $t('original.logining') : $t('original.login') }}
            </el-button>
            <!-- <el-button type="primary" @click="Sign_ins()" :loading="loadding">
              煮热
            </el-button> -->
          </el-form-item>
        </el-form>
        <p style="margin-left:120px;margin-top: -16px;cursor: pointer;"><span>还没账号？</span> <span style="color: rgba(36, 153, 255, 1);"  @click="Sign_ins()">立即注册</span></p>
      </div>
    </div>


    <div class="activate" v-if="dialogVisible">
      <h5 style="width: 100%;font-size: 18px;text-align: center;padding-top: 20px;">登录信息</h5>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForms" label-width="100px" class="demo-ruleForm">

        <el-form-item label="姓名" prop="RealName">
          <el-input v-model="ruleForm.RealName"></el-input>
        </el-form-item>

        <el-form-item label="账号" prop="UserID">
          <el-input v-model="ruleForm.UserID"></el-input>
        </el-form-item>

        <el-form-item label="培养单位" prop="TrainID">
          <!-- <el-input v-model="ruleForm.TrainID"></el-input> -->
          <div class="block">
            <el-cascader ref="wcascader" :options="data" @change="Selected_to_shut_dow" :props="{checkStrictly: true}"  v-model="DeptIDs" :show-all-levels="false"></el-cascader>
          </div>
        </el-form-item>

        <el-form-item label="身份证号" prop="IDCard">
          <el-input v-model="ruleForm.IDCard"></el-input>
        </el-form-item>

        <el-form-item label="手机号" prop="Phone">
          <el-input v-model="ruleForm.Phone"></el-input>
        </el-form-item>

        <el-form-item label="邮箱地址" prop="Email">
          <el-input v-model="ruleForm.Email"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForms')">立即激活</el-button>
        </el-form-item>

        <p v-if="Number(ActiveTimes) > 0" style="color: red;font-size: 12px;margin-left: 135px;">审核未通过，请进行第{{
          Number(ActiveTimes) + 1 }}次修改</p>
      </el-form>
    </div>

    <div v-if="dialogVisible2" style="text-align: center;" class="activate2">
      <div
        style="width: 200px;height: 200px;font-size: 140px;color: #fff;background-color: rgba(36, 153, 255, 1);margin-top: 50px;border-radius: 50%;"
        class="el-icon-message-solid">
      </div>
      <p style="color: rgba(36, 153, 255, 1);font-weight: 700;font-size: 30px;padding-top: 20px;">信息审核中</p>
      <p style="color: #000;padding-top: 20px;color: rgb(143 142 142);font-size: 18px;">请您耐心等待.....</p>
    </div>

    <div v-if="dialogVisible" class="memban"></div>

    <!-- <div class="ts" v-if="ts">
      <el-button type="primary" @click="Continues()"
        style="position: absolute;bottom: 10px;left: 42%;width: 120px;">继续</el-button>
    </div> -->

    <div v-if="dialogVis" style="width: 700px;height: 385px;position: fixed;top: -80px;left: 0px;right: 0px;bottom: 0px;margin: auto;background-color: #fff;box-shadow: 0px 0px 5px white;">
      <h2 style="padding: 15px;text-align:center;color: #000;">选择角色</h2>
      <ul class="CHARACTERS">
        <li v-for="(item,i) in multi_role" :key="i">
          <el-button :class="role_class==i?'class1':'class2'" @click="xz_role(item,i)" type="primary" plain icon="el-icon-s-custom">{{item.roleName}}</el-button>
        </li>
      </ul>
      <el-button type="primary" style="text-align:center;margin-left:220px;height: 45px !important;width: 300px !important;font-size: 18px;position: absolute;bottom:20px" @click="again_logon()">确定</el-button>
    </div>
    
  </div>
</template>
<script>

import JcRange from './JcRange.vue'
export default {
  components: {
    'drag-verify': JcRange,
  },
  data() {
    return {
      role_xx:'',
      role_class: '999',
      multi_role:[],
      dialogVis:false,
      DeptIDs:'',
      ActiveTimes: '',
      data: [],
      dialogVisible: false,
      dialogVisible2: false,
      isPassing: false,
      status: false,
      loadding: false,
      language: true,
      ruleForm: { UserID: '', PWD: '' },
      BGImageBig: '',
      BGImageSmall: '',
      CompanyLogo: '',
      SystemNM: '',
      CompanyNM: '',
      PWD: '', //是否需要密码
      Rejester: '', //是否需要注册
      Vertify: '', //是否需要验证码
      ruleForm: {
        RealName: '',
        UserID: '',
        TrainID: '',
        IDCard: '',
        Phone: '',
        Email: '',
      },
      ruleForm0: {
        RealName0: '',
        UserID0: '',
        TrainID0: '',
        IDCard0: '',
        Phone0: '',
        Email0: '',
      },
      rules: {
        RealName: [
          {required:true,message:'请输入姓名',trigger:'blur'},
        ],
        UserID: [
          {required:true,message:'请输入学号',trigger:'change'}
        ],
        TrainID: [
          {type:'date',required:true,message:'请选择培养单位',trigger:'change'}
        ],
        IDCard: [
          {type:'date',required:true,message:'请输入身份证号',trigger:'change'}
        ],
        Phone: [
          {type:'array',required:true,message:'请输入手机号',trigger:'change'}
        ],
        Email: [
          {required:true,message:'请输入邮箱地址',trigger:'change' }
        ],
      }
    }
  },
  created() {
    let languageConf = localStorage.getItem('language');
    this.language = languageConf == "en" ? false:true;
    this.$i18n.locale = languageConf != '' && languageConf != 'null' && languageConf != undefined ? localStorage.getItem('language') : 'ch';
    if (localStorage.getItem('Conversation') == '1') {
      window.localStorage.clear();
      window.sessionStorage.clear(); 
      localStorage.setItem('language', this.$i18n.locale);
      localStorage.setItem('Conversation','1');
      localStorage.setItem('ConsentForm','1');
    } else {
      window.localStorage.clear();
      window.sessionStorage.clear(); 
      localStorage.setItem('language', this.$i18n.locale);
    }
  },
  methods: {
    again_logon(){
      if (this.role_xx) {
        this.$Http_Post('User/loginagain', { UserID: this.Global.encrypt(this.ruleForm.UserID), PWD: this.Global.encrypt(this.ruleForm.PWD),roleID: this.role_xx.roleID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            let UserActive = res.Data.UserActive;
            if (UserActive == 0) {//未激活
              this.DeptIDs = res.Data.DeptID;
              this.ActiveTimes = res.Data.ActiveTimes;
              this.dialogVisible = true;
              this.dialogVisible2 = false;
              this.ruleForm.RealName = res.Data.RealName;
              this.ruleForm.UserID = res.Data.UserID;
              this.ruleForm.TrainID = res.Data.DeptID;//培养单位
              this.ruleForm.IDCard = res.Data.IDCard;
              this.ruleForm.Phone = res.Data.Phone;
              this.ruleForm.Email = res.Data.Email;
              this.ruleForm0.RealName0 = res.Data.RealName;
              this.ruleForm0.UserID0 = res.Data.UserID;
              this.ruleForm0.TrainID0 = res.Data.DeptID;
              this.ruleForm0.IDCard0 = res.Data.IDCard;
              this.ruleForm0.Phone0 = res.Data.Phone;
              this.ruleForm0.Email0 = res.Data.Email;
              this.Global.SourceNo = res.Data.SourceNo;
              this.Global.openInterview = res.Data.openInterview;
              this.Global.haveInterview = res.Data.Flag;
              this.Global.DeptName = res.Data.DeptName;
              this.Global.TeachName = res.Data.TeachName;
              this.Global.TrainName = res.Data.TrainName;
              this.$store.commit('setToken', res.Data.token);
              this.$Http_Post('DepartMent/GetDeptmentByNodeAPP', {DeptID: '', content: ''}).then((res) => {
                if (res.Code == 0 && res.Data) {
                  let dataList = res.Data;
                  if (dataList.length > 0) {
                    for (let i = 0; i < dataList.length; i++) {
                      if (dataList[i].children.length > 0)
                        this.SetChildrenNode(dataList[i]);
                      else dataList[i].children = undefined;
                    }
                  }
                  this.data = dataList;
                  // this.DeptIDs=this.getParentsById(dataList,this.DeptIDs);
                }
              })
            } else if (UserActive == 2) {//已激活
              sessionStorage.setItem('xinxi', JSON.stringify(res.Data));
              this.Global.SourceNo = res.Data.SourceNo;
              this.Global.openInterview = res.Data.openInterview;
              this.Global.haveInterview = res.Data.Flag;
              this.Global.DeptName = res.Data.DeptName;
              this.Global.TeachName = res.Data.TeachName;
              this.Global.TrainName = res.Data.TrainName;
              this.destroyed();
              this.loadding = false;
              if (res.Data.roleDj == '2') {
                if(res.Data.RoleID == '1057'){
                  sessionStorage.setItem('entity', '管理员');
                }else if(res.Data.RoleID == '1068'){
                  sessionStorage.setItem('entity', '危机管理员');
                }
              } else if (res.Data.roleDj == '5') {
                sessionStorage.setItem('entity', '辅导员');
              } else if (res.Data.roleDj == '3') {
                sessionStorage.setItem('entity', '咨询师');
              } else if (res.Data.roleDj == '4') {
                if(res.Data.RoleID == '1065'  ){
                  sessionStorage.setItem('entity', '校长');
                }else{
                  sessionStorage.setItem('entity', '来访者');
                }
              } else if (res.Data.roleDj == '1') {
                sessionStorage.setItem('entity', '超级管理员');
              }
              sessionStorage.setItem('RoleID', res.Data.RoleID);
              this.$store.commit('setToken', res.Data.token);
              this.$store.commit('login', res.Data);
              this.Global.birthday = res.Data.Birthday;
              this.Global.userID = res.Data.UserID;
              this.Global.realName = res.Data.RealName;
              this.Global.identity = res.Data.Show;
              this.Global.headPhoto = res.Data.HeadPhoto;
              this.Global.roletype = res.Data.roleDj == '2' ? '管理员' : res.Data.roleDj == '3' ? '咨询师' : res.Data.roleDj == '4' ? '来访者' : '超级管理员';
              this.$message({message: this.$t('original.languages2'),type:'success'});
              this.$Http_Post('User/GetMenuButton').then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  sessionStorage.setItem('UserGetMenuButton', JSON.stringify(res.Data));
                  this.$router.push('/views');
                  // if (sessionStorage.getItem('entity') == '来访者') {
                  //   this.ts = true;
                  //   // let timer = setTimeout(() => {
                  //   //   this.$router.push('/views');
                  //   //   // this.$router.push('/ReportData/RPHome');
                  //   // }, 2000)
                  // } else {
                  //   this.$router.push('/views');
                  //   // this.$router.push('/ReportData/RPHome');
                  // }
                }
              })
            } else if (UserActive == 1) {//审批中
              this.dialogVisible2 = true;
              this.dialogVisible = false;
            }
          }else{
            this.reset();
            this.loadding = false;
            this.$message.error(res.Message);
          }
        })
      } else {
        alert('请选择角色！')
      }
    },
    xz_role(item,i){
      this.role_class = i
      this.role_xx = item
    },
    Continues() {
      this.$router.push('/views');
    },
    Selected_to_shut_dow(dt) {
      this.ruleForm.TrainID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    submitForm(formName) {
      if (!this.ruleForm.RealName) {
        this.Global.request_failure("请输入姓名");
        return false;
      }
      if (!this.ruleForm.UserID) {
        this.Global.request_failure("请输入学号");
        return false;
      }
      if (!this.ruleForm.TrainID) {
        this.Global.request_failure("请选择培养单位");
        return false;
      }
      if (!this.ruleForm.IDCard) {
        this.Global.request_failure("请输入身份证号");
        return false;
      }
      if (!this.ruleForm.Phone) {
        this.Global.request_failure("请输入手机号");
        return false;
      }
      if (!this.ruleForm.Email) {
        this.Global.request_failure("请输入邮箱地址");
        return false;
      }
      this.$Http_Post('/Activation/ActivationUser', {
        UserID2: this.ruleForm.UserID,
        DeptID2: this.ruleForm.TrainID,
        RealName2: this.ruleForm.RealName,
        Phone2: this.ruleForm.Phone,
        Email2: this.ruleForm.Email,
        IDCard2: this.ruleForm.IDCard,
        UserID: this.ruleForm0.UserID0,
        DeptID: this.ruleForm0.TrainID0,
        RealName: this.ruleForm0.RealName0,
        Phone: this.ruleForm0.Phone0,
        Email: this.ruleForm0.Email0,
        IDCard: this.ruleForm0.IDCard0,
        Terminal: "PC"
      }).then((res) => {
        if (res.Code == 0) {
          if (res.Data.UserActive == 1) {
            this.dialogVisible = false;
            this.dialogVisible2 = true;
          } else if (res.Data.UserActive == 2) {
            this.$Http_Post('User/GetLogin', { UserID: this.Global.encrypt(this.ruleForm.UserID), PWD: this.Global.encrypt(this.ruleForm.PWD) }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem('xinxi', JSON.stringify(res.Data) );
                this.Global.SourceNo = res.Data.SourceNo;
                this.Global.openInterview = res.Data.openInterview;
                this.Global.haveInterview = res.Data.Flag;
                this.destroyed();
                this.loadding = false;
                if (res.Data.roleDj == '2') {
                  if(res.Data.RoleID == '1057'){
                    sessionStorage.setItem('entity', '管理员');
                  }else if(res.Data.RoleID == '1068'){
                    sessionStorage.setItem('entity', '危机管理员');
                  }
                } else if (res.Data.roleDj == '5') {
                  sessionStorage.setItem('entity', '辅导员');
                } else if (res.Data.roleDj == '3') {
                  sessionStorage.setItem('entity', '咨询师');
                } else if (res.Data.roleDj == '4') {
                  if(res.Data.RoleID == '1065'  ){
                    sessionStorage.setItem('entity', '校长');
                  }else{
                    sessionStorage.setItem('entity', '来访者');
                  }
                } else if (res.Data.roleDj == '1') {
                  sessionStorage.setItem('entity', '超级管理员');
                }
                sessionStorage.setItem('RoleID', res.Data.RoleID);
                this.$store.commit('setToken', res.Data.token);
                this.$store.commit('login', res.Data);
                this.Global.birthday = res.Data.Birthday;
                this.Global.userID = res.Data.UserID;
                this.Global.realName = res.Data.RealName;
                this.Global.identity = res.Data.Show;
                this.Global.headPhoto = res.Data.HeadPhoto;
                this.Global.roletype = res.Data.roleDj == '2' ? '管理员' : res.Data.roleDj == '3' ? '咨询师' : res.Data.roleDj == '4' ? '来访者' : '超级管理员';
                this.$message({ message: this.$t('original.languages2'), type: 'success'});
                this.$Http_Post('User/GetMenuButton').then((res) => {
                  if (res.Code == 200 || res.Code == 0) {
                    sessionStorage.setItem('UserGetMenuButton', JSON.stringify(res.Data));
                    this.$router.push('/views');
                  }
                })
              } else {
                this.reset();
                this.loadding = false;
                this.$message.error(res.Message);
              }
            })
          }
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    change_language() {
      if (this.language) { 
        localStorage.setItem('language', "ch")
        this.$i18n.locale = "ch"
      } else { 
        localStorage.setItem('language', "en")
        this.$i18n.locale = "en"
      }
    },
    passcallback2() {

    },
    reset() {
      this.isPassing = false;
      if (this.$refs.dragVerify != undefined) {
        this.$refs.dragVerify.reset();
      }
    },
    verificationT() {
      this.status = true;
    },
    verificationF() {
      this.status = false;
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.login();
      }
    },
    destroyed() {
      window.removeEventListener('keydown', this.keyDown, false);
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    SetChildrenNode: function (node) {
      if (node.children.length > 0) {
        for (let i = 0; i < node.children.length; i++) {
          this.SetChildrenNode(node.children[i]);
        }
      }
      else node.children = undefined;
    },

    Sign_ins() {
      window.open(process.env.VUE_APP_URLs + 'File/Regist/login.html')
    },

    login() {
      if (!this.isPassing) {
        this.$message({
          message: this.$t('original.languages1'),
          type: 'warning',
        })
        return
      }
      this.loadding = true;
      this.$Http_Post('User/GetLogin', { UserID: this.Global.encrypt(this.ruleForm.UserID), PWD: this.Global.encrypt(this.ruleForm.PWD), }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          let UserActive = res.Data.UserActive;
          if (UserActive == 0) {//未激活
            this.DeptIDs = res.Data.DeptID;
            this.ActiveTimes = res.Data.ActiveTimes;
            this.dialogVisible = true;
            this.dialogVisible2 = false;
            this.ruleForm.RealName = res.Data.RealName;
            this.ruleForm.UserID = res.Data.UserID;
            this.ruleForm.TrainID = res.Data.DeptID;//培养单位
            this.ruleForm.IDCard = res.Data.IDCard;
            this.ruleForm.Phone = res.Data.Phone;
            this.ruleForm.Email = res.Data.Email;
            this.ruleForm0.RealName0 = res.Data.RealName;
            this.ruleForm0.UserID0 = res.Data.UserID;
            this.ruleForm0.TrainID0 = res.Data.DeptID;
            this.ruleForm0.IDCard0 = res.Data.IDCard;
            this.ruleForm0.Phone0 = res.Data.Phone;
            this.ruleForm0.Email0 = res.Data.Email;
            this.Global.SourceNo = res.Data.SourceNo;
            this.Global.openInterview = res.Data.openInterview;
            this.Global.haveInterview = res.Data.Flag;
            this.Global.DeptName = res.Data.DeptName;
            this.Global.TeachName = res.Data.TeachName;
            this.Global.TrainName = res.Data.TrainName;
            this.$store.commit('setToken', res.Data.token);
            this.$Http_Post('DepartMent/GetDeptmentByNodeAPP', {DeptID: '', content: ''}).then((res) => {
              if (res.Code == 0 && res.Data) {
                let dataList = res.Data;
                if (dataList.length > 0) {
                  for (let i = 0; i < dataList.length; i++) {
                    if (dataList[i].children.length > 0)
                      this.SetChildrenNode(dataList[i]);
                    else dataList[i].children = undefined;
                  }
                }
                this.data = dataList;
                // this.DeptIDs=this.getParentsById(dataList,this.DeptIDs);
              }
            })
          } else if (UserActive == 2) {//已激活
            sessionStorage.setItem('xinxi', JSON.stringify(res.Data));
            this.Global.SourceNo = res.Data.SourceNo;
            this.Global.openInterview = res.Data.openInterview;
            this.Global.haveInterview = res.Data.Flag;
            this.Global.DeptName = res.Data.DeptName;
            this.Global.TeachName = res.Data.TeachName;
            this.Global.TrainName = res.Data.TrainName;
            this.destroyed();
            this.loadding = false;
            if (res.Data.roleDj == '2') {
              if(res.Data.RoleID == '1057'){
                sessionStorage.setItem('entity', '管理员');
              }else if(res.Data.RoleID == '1068'){
                sessionStorage.setItem('entity', '危机管理员');
              }
            } else if (res.Data.roleDj == '5') {
              sessionStorage.setItem('entity', '辅导员');
            } else if (res.Data.roleDj == '3') {
              sessionStorage.setItem('entity', '咨询师');
            } else if (res.Data.roleDj == '4') {
              if(res.Data.RoleID == '1065'  ){
                sessionStorage.setItem('entity', '校长');
              }else{
                sessionStorage.setItem('entity', '来访者');
              }
            } else if (res.Data.roleDj == '1') {
              sessionStorage.setItem('entity', '超级管理员');
            }
            sessionStorage.setItem('RoleID', res.Data.RoleID);
            this.$store.commit('setToken', res.Data.token);
            this.$store.commit('login', res.Data);
            this.Global.birthday = res.Data.Birthday;
            this.Global.userID = res.Data.UserID;
            this.Global.realName = res.Data.RealName;
            this.Global.identity = res.Data.Show;
            this.Global.headPhoto = res.Data.HeadPhoto;
            this.Global.roletype = res.Data.roleDj == '2' ? '管理员' : res.Data.roleDj == '3' ? '咨询师' : res.Data.roleDj == '4' ? '来访者' : '超级管理员';
            this.$message({message: this.$t('original.languages2'),type:'success'});
            this.$Http_Post('User/GetMenuButton').then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                sessionStorage.setItem('UserGetMenuButton', JSON.stringify(res.Data));
                this.$router.push('/views');
                // if (sessionStorage.getItem('entity') == '来访者') {
                //   this.ts = true;
                //   // let timer = setTimeout(() => {
                //   //   this.$router.push('/views');
                //   //   // this.$router.push('/ReportData/RPHome');
                //   // }, 2000)
                // } else {
                //   this.$router.push('/views');
                //   // this.$router.push('/ReportData/RPHome');
                // }
              }
            })
          } else if (UserActive == 1) {//审批中
            this.dialogVisible2 = true;
            this.dialogVisible = false;
          }
        } else if(res.Code == 809){
          this.dialogVis  = true;

          this.multi_role = res.Data;
          console.log(this.multi_role)

        }else{
          this.reset();
          this.loadding = false;
          this.$message.error(res.Message);
        }
      })
    },

    getParentsById(list, id) {
      for (let i in list) {
        if (list[i].DeptID == id) {//这里的no根据你的需求可进行改变
          //查询到就返回该数组对象的value
          return [list[i].DeptID];
        }
        if (list[i].children) {
          let node = this.getParentsById(list[i].children, id);
          if (node !== undefined) {
            //查询到把父节把父节点加到数组前面
            node.unshift(list[i].DeptID);
            return node;
          }
        }
      }
    },
  },
  mounted() {
    //绑定事件enter登录
    window.addEventListener('keydown', this.keyDown);
    this.$Http_Post('User/GetConfigurationTable').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.BGImageBig = res.Data.BGImageBig;
        this.BGImageSmall = res.Data.BGImageSmall;
        this.CompanyLogo = res.Data.CompanyLogo;
        this.SystemNM = res.Data.systemNM;
        this.CompanyNM = res.Data.CompanyNM;
        this.PWD = res.Data.PWD;
        this.Rejester = res.Data.Rejester;
        this.Vertify = res.Data.Vertify;
        this.Global.companyLogo = res.Data.CompanyLogo;
        this.Global.systemNM = res.Data.systemNM;
        sessionStorage.setItem('companyNM', res.Data.CompanyNM);
        this.$store.commit('setSystemInfo', {
          CompanyLogo: res.Data.CompanyLogo,
          CompanyNM: res.Data.CompanyNM,
          SystemNM: res.Data.systemNM,
        });
      }
    })
    this.$store.commit('removeToken');
    this.$store.commit('logout');
  },
}
</script>
<style>
.login .CHARACTERS{width: 400px;margin: auto;width: 90%;margin-left: 5%;text-align: center;height: 240px;overflow: auto;}
.login .CHARACTERS li{height: 45px;line-height: 45px;text-align: center;margin-top: 10px;width: 400px;margin-left: 116px;}
.login .CHARACTERS li button{width: 100%;height: 100%;padding: 0 !important;margin: 0 !important;border-radius: 0px;height: 100% !important;font-size: 16px;}
.login .CHARACTERS li .class1{
  width: 100%;height: 100%;padding: 0 !important;margin: 0 !important;border-radius: 0px;height: 100% !important;font-size: 16px;background: #409EFF;
}
.login .CHARACTERS li .class2{
  width: 100%;height: 100%;padding: 0 !important;margin: 0 !important;border-radius: 0px;height: 100% !important;font-size: 16px;
}
.login h2 {text-align: center;font-size: 22px;padding-top: 100px;color: #fff;}
.login .activate {width: 800px;height: 550px;position: fixed;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;background-color: #fff;z-index: 2222;}
.login .activate2 {width: 800px;height: 530px;position: fixed;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;background-color: #fff;z-index: 2222;}
.login .activate form {margin-left: 175px;}
.login .memban {width: 100%;height: 100%;background-color: #000;opacity: 0.5;position: relative;z-index: 2000;}
.login .login-content-right .el-input {width: 80%;}
.login {background-size: 100% 100%;position: relative !important;z-index: 9 !important;}
.login .ts {width: 800px;height: 500px;position: fixed;top: 0px;left: 0px;right: 0px;bottom: 0px;margin: auto;background-color: #fff;z-index: 2222;background-image: url('../assets/20230425183732.png');background-size: 100% 100%;}
.login-content {width: 700px;height: 385px;position: fixed;top: -80px;left: 0px;right: 0px;bottom: 0px;margin: auto;background-color: #fff;}
.login-content-left {background-size: 100% 100%;width: 336px;height: 385px;float: left;}
.login-content-left img {width: 100%;height: 100%;}
.login-content-right {float: right;height: 100%;}
.login-content-right>div {font-size: 30px;width: 333px;height: 80px;}
.login-content-right>div .sxds {background-size: 100% 100%;display: inline-block;height: 50px;width: 50px;margin-top: 40px;margin-left: 30px;}
.login-content-right>div span {position: absolute;top: 54px;color: #0d78e3;font-weight: bold;text-shadow: 2px 2px 2px #9dc7f1;font-size: 22px;}
.login form {width: 364px;margin-top: 25px;}
.login .login-content-right form input {text-align: center;border: none !important;border-bottom: 1px solid #000 !important;}
.login .login-content-right .el-input__inner {border: none;border-bottom: 1px solid #adadad !important;border-radius: 0px;text-align: left;}
.login button {width: 250px;height: 46px;background-color: rgba(36, 153, 255, 1);border-radius: 28px;margin-top: 20px;}
.f {position: absolute;top: 50%;left: 50%;min-width: 100%;min-height: 100%;width: auto;height: auto;z-index: -9999;-webkit-transform: translateX(-50%) translateY(-50%);transform: translateX(-50%) translateY(-50%);-webkit-transition: 1s opacity;transition: 1s opacity;background-color: skyblue;}
.login {position: fixed;overflow: hidden;z-index: -10000;background-color: #87ceeb;
}
.f,.login {width: 100%;height: 100%;}
.login .el-row{margin-bottom:0px !important}
.login:before {content: '';position: absolute;width: 100%;height: 100%;display: block;z-index: -1000;top: 0;left: 0;background: rgba(90, 20, 10, 0.2);}
.login .login-content-right .el-form-item__content { margin-left: 55px !important;}
.login .login-content {width: 700px;height: 385px;position: fixed;top: -80px;left: 0px;right: 0px;bottom: 0px;margin: auto;background-color: #fff;box-shadow: 0px 0px 5px white;}
.login .el-input__inner {width: 100% !important;}
.login .el-input__inner {width: 100% !important;}
.login .el-dialog {z-index: 301;}
</style>
